import * as React from 'react';
import { useRouteError } from 'react-router-dom';

import ErrorLayout from 'components/shared/ErrorLayout/ErrorLayout';

const ErrorPage: React.FC = () => {
  const error = useRouteError() as { status?: number };

  const isNotFound = error.status === 404;

  return <ErrorLayout isNotFound={isNotFound} />;
};

export default ErrorPage;
